import { useCallback } from "react";

export const useWidth = (divRefs: (HTMLDivElement | null)[]) => {
  const getWidths = useCallback(
    () =>
      divRefs.map((divRef: HTMLDivElement | null) => {
        if (divRef) {
          return divRef.clientWidth;
        }
        return 0;
      }),
    [divRefs]
  );

  return { getWidths };
};
